var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.3536 4.14066C14.5488 3.9454 14.5488 3.62882 14.3536 3.43356L11.1716 0.251575C10.9763 0.0563133 10.6597 0.0563133 10.4645 0.251575C10.2692 0.446838 10.2692 0.76342 10.4645 0.958682L13.2929 3.78711L10.4645 6.61554C10.2692 6.8108 10.2692 7.12738 10.4645 7.32264C10.6597 7.51791 10.9763 7.51791 11.1716 7.32264L14.3536 4.14066ZM0 4.28711H14V3.28711H0V4.28711Z","fill":"#F000000"}));
}

Arrow.defaultProps = {"width":"15","height":"8","viewBox":"0 0 15 8","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
